'use strict'

import HttpClient from './HttpClient'

class User extends HttpClient {
  loginHeaders = {
    'app-key': process.env.VUE_APP_LOGISTY_API_APP_KEY
  }
  emailRegister (data) {
    var url = '/api/web/app/register'

    return this.sendPost(url, this.loginHeaders, data)
  }
  emailLogin (data) {
    var url = '/api/web/app/login'

    return this.sendPost(url, this.loginHeaders, data)
  }
  checkStatus () {
    var url = '/api/web/app/check/company/status'

    return this.sendPost(url, this.headers)
  }
  changePassword (data) {
    var url = '/api/web/app/change/password'

    return this.sendPut(url, this.headers, data)
  }
  requestResetPassword (data) {
    var url = '/api/web/app/request/reset/password'

    return this.sendPost(url, this.loginHeaders, data)
  }
  resetPassword (data) {
    var url = '/api/web/app/reset/password'

    return this.sendPut(url, this.loginHeaders, data)
  }
}

export default User
